// extracted by mini-css-extract-plugin
export default {"logo":"logo-v4_logo__EKpyc","small":"logo-v4_small__vC5jd","medium":"logo-v4_medium__xCTpU"};